import script from "./ChannelConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChannelConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./ChannelConfirmation.vue?vue&type=style&index=0&id=49789096&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\client-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49789096"]])

export default __exports__